<template>
  <div class="project-management-container">
    <!-- 设备列表视图 -->
    <div>
      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span class="page-title">{{ $t("message.clientProject.title") }}</span>
            <!-- Search Form -->
            <el-form :inline="true" :model="queryParams" class="search-form">


              <el-form-item :label="$t('message.device.company')">
                <el-tree-select
                  v-model="queryParams.companyId"
                  :data="companyTreeData"
                  :props="treeProps"
                  :placeholder="$t('message.device.selectCompany')"
                  check-strictly
                  clearable
                  filterable
                  style="width: 200px"
                  @change="handleSearch"
                />
              </el-form-item>
              

              <el-form-item :label="$t('message.clientProject.name')">
                <el-input
                  v-model="queryParams.name"
                  :placeholder="$t('message.clientProject.inputName')"
                  clearable
                  @change="handleSearch"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleSearch">
                  {{ $t("message.clientProject.search") }}
                </el-button>
                <el-button @click="resetSearch">
                  {{ $t("message.clientProject.reset") }}
                </el-button>
                <el-button v-if="canAddProject" @click="handleAdd">
                  {{ $t("message.clientProject.add") }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <el-table 
          :data="filteredDeviceList" 
          border 
          style="width: 100%"
          v-loading="loading"
          :element-loading-text="$t('message.common.loading')"
        >
          <el-table-column
            prop="id"
            :label="$t('message.clientProject.id')"
            width="80"
            sortable
            v-if="false"
          />
          <el-table-column
            prop="name"
            :label="$t('message.clientProject.name')"
            width="300"
            sortable
          />          
          <el-table-column
            prop="company_name"
            :label="$t('message.clientProject.company')"
            width="150"
            sortable
            v-if="false"
          />
          <el-table-column
            prop="company_id"
            :label="$t('message.clientProject.company')"
            width="150"
            sortable
            v-if="false"
          />
          <el-table-column
            :label="$t('message.clientProject.state')"
            width="100"
            sortable
            v-if="false"
          >
            <template #default="scope">
              <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'">
                {{
                  scope.row.state === 1
                    ? $t("message.clientProject.Allonline")
                    : $t("message.clientProject.offline")
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="location"
            :label="$t('message.clientProject.location')"
            width="150"
            sortable
            v-if="false"
          />
          
          <el-table-column
            prop="description"
            :label="$t('message.clientProject.description')"
            width="150"
            sortable
            v-if="false"
          />
          
          <el-table-column
            prop="created_at"
            :label="$t('message.clientProject.createTime')"
            width="180"
            sortable
            v-if="false"
          >
            <template #default="scope">
              {{ formatDate(scope.row.created_at) }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('message.clientProject.actions')" width="240">
            <template #default="scope">
              <el-button size="small" type="primary" @click="handleViewDevice(scope.row)">
                {{ $t("message.clientProject.monitor") }}                
              </el-button>            
             <el-button   v-if="canEditProject"  size="small" @click="handleEdit(scope.row)">{{
                $t("message.gateway.edit")
              }}</el-button>
              <el-button v-if="canDeleteProject" size="small" type="danger" @click="handleDelete(scope.row)">{{
                $t("message.gateway.delete")
              }}</el-button>
            
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :total="pagination.total"
            :page-sizes="[10, 20, 30, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
          />
        </div>
      </el-card>
    </div>

    <!-- 监控弹窗 style="height:600px; width: 80%; "-->
    <el-dialog
      v-model="monitorDialogVisible"
      :title="monitorDialogTitle"      
      :close-on-click-modal="false"
      fullscreen
      class="custom-dialog"      
    >                           
    <!-- 自定义标题 -->
      <template #header>
        <div class="custom-dialog-header">
          <span class="dialog-title">{{ monitorDialogTitle }}</span>
          <el-button 
            type="primary" 
            link 
            @click="monitorDialogVisible   = false"
            class="back-button"
          >
            <el-icon><ArrowLeft /></el-icon>            
            {{ t("message.common.exit") }}   
          </el-button>
        </div>
      </template>
      <!-- 2. 弹窗内容容器：限制高度，为滚动提供边界 -->
      <div class="dialog-content">
        <device-monitor 
          v-if="monitorDialogVisible"          
          :businessId="businessId"
          :projectId="currentProjectId"
          :projectName="currentProjectName"
        />      
      </div>
    </el-dialog>

  <el-dialog
    v-model="ProjectDeailAddDialogVisible"
    :title="currentProjectTitle"
    :close-on-click-modal="false"
    fullscreen
    class="custom-dialog"
  >
    <!-- 自定义标题 -->
    <template #header>
      <div class="custom-dialog-header">
        <span class="dialog-title">{{ currentProjectTitle }}</span>
        <el-button 
          type="primary" 
          link 
          @click="closeProjectDialog"
          class="back-button"
        >
          <el-icon><ArrowLeft /></el-icon>
          {{ t("message.common.exit") }}
        </el-button>
      </div>
    </template>
    <!-- 弹窗内容 -->
    <div class="dialog-content">
      <ProjectDeailAdd
        v-if="ProjectDeailAddDialogVisible"
        :companyId="currentCompanyId"
        :businessId="businessId"
        :businessName="businessName"
        :projectId="currentProjectId"
        :projectName="currentProjectName"
        :currentProjectAddOrEdit="currentProjectAddOrEdit"
        @close-dialog="closeProjectDialog"
        @save-success="handleProjectSaveSuccess"
      />
    </div>
  </el-dialog>

  </div>
</template>
<script setup>
import { ref, reactive, onMounted,watch, computed } from "vue";
import { ElMessage,ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import DeviceMonitor from "./ClientDeviceMonitor.vue"; // 导入监控组件
import ProjectDeailAdd from "./ClientProjectDeailAdd.vue"; // 导入监控组件
import {projectList,projectDelete} from "@/api/ProjectManger";
import { getCompanyTree } from "@/api/CompanyManager";
import { useRoute } from 'vue-router';
import { usePermission } from '@/composables/usePermission'

const { canAddProject, canEditProject,canDeleteProject,refresh } = usePermission()

const { t } = useI18n();

// 监控弹窗状态
const monitorDialogVisible = ref(false);
const monitorDialogTitle = ref("");
const currentProjectId = ref(null);
const currentProjectAddOrEdit = ref(0);
const currentCompanyId = ref(0);
const currentProjectName = ref('');
const currentProjectTitle = ref('');
const ProjectDeailAddDialogVisible = ref(false);

//import { useRoute,useRouter } from 'vue-router';


//const router = useRouter();
const route = useRoute();

const businessId = computed(() => route.query.businessId);
const businessName = computed(() => route.query.businessName);

// 状态筛选
const activeStatus = ref('all');

// 响应式数据
const deviceList = ref([]);
const loading = ref(false); 

// 查询参数 - 修复：使用普通值而不是computed 
const queryParams = reactive({
  companyId: null,
  businessId: 0, // 改为普通字符串
  name: "",
  pageNum: 1,
  pageSize: 10,
});

const queryCompanyTreeParams = reactive({
  companyId: null,
});
const companyTreeData = ref([]);

const treeProps = {
  value: "id",
  label: "name",
  children: "children",
};

// 分页
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0,
});

const filteredDeviceList = computed(() => {
  if (activeStatus.value === 'all') {
    return deviceList.value;
  } else if (activeStatus.value === 'online') {
    return deviceList.value.filter(project => project.state === 1);
  } else {
    return deviceList.value.filter(project => project.state === 0);
  }
});


// 关闭项目详情对话框的方法
const closeProjectDialog = () => {
  ProjectDeailAddDialogVisible.value = false;
};

// 处理保存成功后的操作
const handleProjectSaveSuccess = () => {
  closeProjectDialog();
  // 可以添加其他逻辑，如刷新列表
  handleSearch();
};

const handleEdit = (row) => {

  //2是编辑  
  currentProjectAddOrEdit.value =2;
  currentProjectId.value = row.id;
  currentCompanyId.value= row.company_id;
  currentProjectName.value = row.name;  
  const editText = t('message.common.edit');
  currentProjectTitle.value= `${ row.name} - ${editText}`
  //currentProjectId.value =0
  //currentProjectName.value = t("message.clientProject.editProjectTitle")
  ProjectDeailAddDialogVisible.value =true;

//    ElMessage.error(`${currentProjectAddOrEdit.value} 的编辑功能正在建设中`);
  
};

const handleDelete = (row) => {
  ElMessageBox.confirm(    
    t("message.clientProject.deleteConfirm", { name: row.name }),
    t("message.common.tip"),
    {
      confirmButtonText: t("message.common.confirm"),
      cancelButtonText: t("message.common.cancel"),
      type: "warning",
    }
  )
    .then(async () => {
      try {
        const requestData = {
          id: row.id
        };
        const res = await projectDelete(requestData);        
        if(res?.success)
        {
            ElMessage.success(t("message.clientProject.deleteSuccess"));
            handleSearch();
        }
        else
        {
            ElMessage.warning(res?.msg);
        }
                
      } catch (error) {
        ElMessage.error(error.message || t("message.clientProject.deleteFailed"));
      }
    })
    .catch(() => {
      ElMessage.info(t("message.clientProject.deleteCancelled"));
    });
};

// 打开监控弹窗
const handleViewDevice = (project) => {
  currentProjectId.value = project.id;
  currentProjectName.value = project.name;
  const realTimeText = t('message.clientProject.RealTimeMonitor');
  monitorDialogTitle.value =  project.name ? `${project.name} - ${realTimeText}` : realTimeText; //`${project.name} - $t('message.clientProject.RealTimeMonitor')`;
  monitorDialogVisible.value = true;
};

const fetchDevices = async () => {
  loading.value = true;
  try {
    const params = {
      companyId: queryParams.companyId,
      businessId: queryParams.businessId, // 使用queryParams中的值
      name: queryParams.name,
      pageNum: queryParams.pageNum,
      pageSize: queryParams.pageSize,
    };

    console.log('请求参数:', params); // 调试用

    const res = await projectList(params);
    if(!res.success) {
      ElMessage.error(res?.msg);  
      return;
    }
    deviceList.value = res.data.list;
    pagination.total = res.data.totalCount;
  } catch (error) {
    ElMessage.error(error.message || t("message.device.fetchError"));
  } finally {
    loading.value = false;
  }
};

//新增项目
const handleAdd = () => {
   
  currentCompanyId.value =queryParams.companyId;
  currentProjectAddOrEdit.value = 1;
  currentProjectName.value ='';   
  currentProjectId.value =0
  currentProjectTitle.value = t("message.clientProject.addProjectTitle")
  ProjectDeailAddDialogVisible.value =true;

  //router.push(`clientProjectDeailAdd?businessId=${businessId.value}`);

};

const handleSearch = () => {
  queryParams.pageNum = 1; 
  fetchDevices();
};

const resetSearch = () => {
  queryParams.name = "";
  queryParams.pageNum = 1;
  handleSearch();
};
  
const handlePageChange = (val) => {
  queryParams.pageNum = val;
  fetchDevices();
};

const handleSizeChange = (val) => {
  queryParams.pageSize = val;
  fetchDevices();
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .format(date)
    .replace(/\//g, "-");
};

const loadCompanyTree = async () => {
  try {
    const res = await getCompanyTree(queryCompanyTreeParams);
    companyTreeData.value = res.data.list;

    if (companyTreeData.value.length > 0 && !queryParams.companyId) {      
      queryParams.companyId = companyTreeData.value[0].id;
    }
  } catch (error) {
    ElMessage.error(t("message.device.loadCompanyFailed"));
  }
};


// 正确写法：监控 businessId 变化
watch(
  () => businessId.value,
  async (newBusinessId, oldBusinessId) => {
    console.log('businessId 发生变化:', oldBusinessId, '->', newBusinessId);
    if (newBusinessId) {
      // 更新查询参数中的 businessId（现在是普通字符串）
      queryParams.businessId = newBusinessId;
      // 重置页码并重新加载数据
      queryParams.pageNum = 1;
      await handleSearch();
    }
  },
  { immediate: true }
);

// ✅ 在路由变化时刷新权限
watch(
  () => route.fullPath,
  () => {
    refresh()
  }
)

// 初始化
onMounted(async () => { 
  refresh();
  // 初始化时设置 businessId
  if (businessId.value) {
    queryParams.businessId = businessId.value;
  }
  await loadCompanyTree();
  await handleSearch();  
  
});
</script>



<style scoped>
.project-management-container {
  padding: 5px;
  height: 95%;
  overflow: auto;
}
 

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.search-form {
  margin-top: 0px;
  height: 5px;
}

.search-form :deep(.el-form-item) {
  margin-right: 15px;
  margin-bottom: 10;
}

/* 其他样式保持不变 */
.pagination {
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
}


/* 3. 弹窗样式：限制整体高度 */
:deep(.custom-dialog .el-dialog__body) {
  padding: 0; /* 移除默认内边距，避免高度计算误差 */
  height: calc(100% - 60px); /* 满屏状态下设置90vh或者calc(100% - 60px)才可以，弹窗内容区高度 */
  overflow: hidden; /* 禁止内容区自身滚动，让内部容器滚动 */
}

/* 4. 弹窗内容容器：填充弹窗内容区 */
.dialog-content {
  height: 100%;
  padding: 0px; /* 自定义内边距 */
  overflow: hidden; /* 禁止内容区自身滚动，让内部容器滚动 */
  box-sizing: border-box;
}
 
/* 响应式设计 */
@media (max-width: 768px) {
  .project-management-container {
    padding: 0px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .search-form :deep(.el-form-item) {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .search-form :deep(.el-input) {
    width: 100%;
  }

  /* .monitor-dialog :deep(.el-dialog) {
    margin: 0px !important;
  } */
}
</style>